import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Divider, Modal, Space, Tabs } from "antd"
import styled from "styled-components"
import ImageTabRightImage from "./ImageTabRightImage";
import ImageTabRightPrompt from "./ImageTabRightPrompt";
import { useEffect } from "react";
import dayjs from "dayjs";
import createImageGPT from "./controller/createImageGPT";
import s3Controller from "controllers/s3Controller";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND
const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 500px;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-left: 10px;
    overflow: auto;

    & > .ant-space-item .ant-space {
      width: 100%;
    }

    & > .ant-space-item:nth-child(1) {
      text-align: left;
    }

    & > .ant-space-item:nth-child(2) {
      flex-grow: 1;
      display: flex;
      overflow: auto;
    }
  }
`

function ImageTabRight ({
  stateHandler,
  prompt,
  rightBox,
  tableParams,
  gptModel
}) {

  const items = [
    { label: "이미지", key: "item-1", style: { height: "100%", overflow:"auto" }, children: <ImageTabRightImage rightBox={rightBox} stateHandler={stateHandler} gptModel={gptModel}/> }, // remember to pass the key prop
    { label: "프롬프트", key: "item-2", style: { height: "100%", overflow:"auto" }, children: <ImageTabRightPrompt rightBox={rightBox} prompt={prompt} stateHandler={stateHandler} gptModel={gptModel}/> },
  ];

  const preDataHandler = () => {
    const {current, pageSize, total} = tableParams.pagination
    const newRowIndex = rightBox[1].indexNumber -1

    if(current !== 1 && newRowIndex < 0) {
      stateHandler("tableParams", {
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          current: current -1
        }
      })
      stateHandler("newPageRef", true)
      stateHandler("rowIndex", pageSize -1)
    } else {
      if(newRowIndex >= 0) {
        stateHandler("rowIndex", newRowIndex)
      }
    }
  }

  const nextDataHandler = () => {
    const {current, pageSize, total} = tableParams.pagination
    const newRowIndex = rightBox[1].indexNumber +1
    const maxPage = total%pageSize === 0 ? total/pageSize : parseInt(total/pageSize) +1
    const maxPageRow = total%pageSize || pageSize
    console.log(current, newRowIndex, maxPage, maxPageRow)

    if(current !== maxPage) {
      if(newRowIndex >= pageSize) {
        stateHandler("tableParams", {
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            current: current +1
          }
        })
        stateHandler("newPageRef", true)
        stateHandler("rowIndex", 0)
      } else {
        stateHandler("rowIndex", newRowIndex)
      }
    } else {
      if(newRowIndex < maxPageRow) {
        stateHandler("rowIndex", newRowIndex)
      }
    }
    // if(current !== maxPage && newRowIndex >= pageSize) {
    //   stateHandler("tableParams", {
    //     ...tableParams,
    //     pagination: {
    //       ...tableParams.pagination,
    //       current: current +1
    //     }
    //   })
    //   stateHandler("newPageRef", true)
    //   stateHandler("rowIndex", 0)
    // } else {
    //   if(newRowIndex < maxPageRow) {
    //     stateHandler("rowIndex", newRowIndex)
    //   }
    // }
  }

  const cancelHandler = () => {
    stateHandler("rowIndex", null)
  }

  const createImage = () => {
    const record = rightBox[1]
    const prompt = record.final_prompt

    if(prompt) {
      stateHandler("loading", true)
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const fileName = `wordimage_${record.id}_${currentVer}.jpeg`;
      const size = gptModel.image_size

      createImageGPT(fileName, size,  prompt)
      .then(imageFile=>{
        s3Controller.s3Upload(imageFile,"word_image",(err, data)=>{
          //업로드가 완료되었을 경우 콜백
          if (err) {
            console.log(err)
            Modal.error({
              title:"에러",
              okText:"확인",
              content:"s3에 업로드 중 에러가 발생해서 생성을 취소했습니다."
            })
          } else {
            const newKey = data.Key
            const newFile = data.Key.split("/")[1]
            axios.post(`${backend}/contents/new_word/image/new-image/${record.id}`,
            {newFile, size})
            .then(res=>{
              const instance = {...record}
              instance.image_count = instance.image_count + 1
              // dataChangeHandler(instance, "image_count")
              stateHandler("sourceDataForRightBox", instance)
              stateHandler("loading", false)
            })
            .catch(err=>{
              console.log(err)
              stateHandler("loading", false)
              s3Controller.s3DeleteFile(newKey, (err, data) => {
                if (err) console.log(err);
              });
              Modal.error({
                title:"에러",
                okText:"확인",
                content:"서버 에러가 발생해서 이미지를 저장하지 못했습니다."
              })
            })
          }
        })
        
      })
      .catch(err=>{
        stateHandler("loading", false)
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"AI 에러가 발생해서 문장을 생성하지 못했습니다."
        })
      })
    }
  }

  useEffect(()=>{
    
  },[rightBox])

  return (
    <div>
      <StyledSpace>
        <Space direction="vertical" size={0}>
          <Space size={0} style={{padding:"6px 6px 6px 10px", fontSize:"15px", fontWeight:"500"}}>이미지 목록</Space>
          <Divider style={{display:"flex", margin:"0px"}}/>
        </Space>

        <Tabs items={items} destroyInactiveTabPane={true} size={"small"} style={{flexGrow:1, margin:"10px"}} type="card"></Tabs>

        <Space direction="vertical" size={0}>
          <Divider style={{display:"flex", margin:"0px"}}/>
          <Space size={0} style={{padding:"10px 6px 6px 6px", width:"100%", justifyContent:"right"}}>
            {/* <Button>내용 초기화</Button> */}
            <Space>
              <Button onClick={preDataHandler}><LeftOutlined/>이전</Button>
              <Button type="primary" onClick={createImage}><CheckOutlined/>생성</Button>
              <Button onClick={nextDataHandler}><RightOutlined/>다음</Button>
              <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
            </Space>
          </Space>
        </Space>

      </StyledSpace>
    </div>
  )
}

export default ImageTabRight